<template>
  <div class="pretest">
    <div class="main-content">
      <div class="title">
        <h2>候考</h2>
        <p class="tip">
          考试开始前，请考生<strong>在此页面耐心等待</strong>。<span
            v-if="needIdentity"
            >如退出，考生需重新登录进行身份核验。</span
          >
        </p>
      </div>
      <div class="time-wrap" v-if="testInfo.start_time && !hasNoTest">
        <div class="time">
          <countdown
            :remoteTime="testInfo.start_time"
            @listen="listen"
          ></countdown>
        </div>
        <p class="time-txt">
          <span>小时</span><span class="time-space">分钟</span><span>秒</span>
        </p>
      </div>
      <div class="info-wrap">
        <h3>考生信息</h3>
        <div class="info" v-if="!hasNoTest">
          <template v-if="!loading">
            <template v-if="shandongKeXieInfo">
              <div class="row" v-if="testInfo.start_time">
                <span class="label">开考时间</span>
                <span class="text">{{ testInfo.start_time | date }}</span>
              </div>
              <div class="row" v-if="testInfo.exam_time">
                <span class="label">考试时长</span>
                <span class="text">{{ testInfo.exam_time }}分钟</span>
              </div>
              <div class="row" v-if="shandongKeXieInfo.level">
                <span class="label">赛级</span>
                <span class="text">{{ shandongKeXieInfo.level }}</span>
              </div>
              <div class="row" v-if="shandongKeXieInfo.group">
                <span class="label">组别</span>
                <span class="text">{{ shandongKeXieInfo.group }}</span>
              </div>
              <div class="row" v-if="shandongKeXieInfo.event">
                <span class="label">赛项</span>
                <span class="text" style="width:250px;">{{ shandongKeXieInfo.event }}</span>
              </div>
            </template>
            <template v-else>
              <div
                class="row"
                v-if="
                  testInfo.name && (testConfig.show_examinee_name || isTouristsId)
                "
              >
                <span class="label">{{
                  isChongQing ? "用户名" : "考生姓名"
                }}</span>
                <span class="text">{{ testInfo.name }}</span>
              </div>
              <div class="row" v-if="testInfo.identity_num">
                <span class="label">身份证号码</span>
                <span class="text">{{ testInfo.identity_num }}</span>
              </div>
              <div class="row" v-if="testInfo.mobile">
                <span class="label">手机号码</span>
                <span class="text">{{ testInfo.mobile }}</span>
              </div>
              <div class="row" v-if="testInfo.area">
                <span class="label">所在地区</span>
                <span class="text">{{ testInfo.area }}</span>
              </div>
              <div class="row" v-if="testInfo.school">
                <span class="label">所在学校</span>
                <span class="text">{{ testInfo.school }}</span>
              </div>
              <div
                class="row"
                v-if="
                  testInfo.start_time &&
                  $route.path.split('/')[1].indexOf(weishengRoute) < 0
                "
              >
                <span class="label">开考时间</span>
                <span class="text">{{ testInfo.start_time | date }}</span>
              </div>
              <div class="row" v-if="testInfo.score">
                <span class="label">卷面总分</span>
                <span class="text">{{ testInfo.score }}分</span>
              </div>
              <div class="row" v-if="testInfo.exam_time">
                <span class="label">考试时长</span>
                <span class="text">{{ testInfo.exam_time }}分钟</span>
              </div>
              <div class="row" v-if="testInfo.exam_name">
                <span class="label">考试名称</span>
                <span class="text">{{ testInfo.exam_name }}</span>
              </div>
            </template>
          </template>
        </div>
        <div v-else class="no-info">
          <p class="icon"></p>
          <p class="error-tip">考试卷正在配置中</p>
        </div>
      </div>
      <div class="bottom">
        <template v-if="hasNoTest">
          <button class="close-btn" @click="close">知道了</button>
        </template>
        <template v-else>
          <p v-if="testInfo.isLate" class="error-tip">
            迟到{{ testInfo.last_come_in_minute }}分钟，禁止进入考场
          </p>
          <template v-else>
            <button
              @click="goDetect"
              class="check-btn"
              v-if="theme.deviceCheckOpen"
            >
              设备检测
            </button>
            <button
              class="start-btn"
              :disabled="showTime || btnLoading"
              :class="{ disabled: showTime || btnLoading }"
              @click="startTest"
            >
              <span v-show="btnLoading">
                <loading
                  :box-size="4"
                  :round-size="1"
                  :color="'#fff'"
                ></loading>
              </span>
              开始考试
            </button>
          </template>
        </template>
      </div>
    </div>
    <detect-tip-modal
      ref="detectRef"
      v-show="showDetectModal"
      @close="showDetectModal = false"
      @goTest="startTest(false)"
    ></detect-tip-modal>
    <commitment-modal
      v-show="showCommitmentModal"
      @close="showCommitmentModal = false"
      @goTest="startTest(false)"
    ></commitment-modal>
  </div>
</template>

<script>
import Countdown from '@/components/Countdown'
import { mapState } from 'vuex'
import { post, get } from '@/utils/ajax'
import { getTouristsToken, getTouristsVal } from '@/utils'
import Loading from '@/components/Loading'
import DetectTipModal from '@/views/components/DetectTipModal'
import CommitmentModal from '@/views/components/CommitmentModal'
import axios from 'axios'

export default {
  components: {
    Countdown,
    Loading,
    DetectTipModal,
    CommitmentModal
  },
  computed: {
    ...mapState(['weishengRoute', 'testConfig', 'theme']),
    testInfo() {
      return this.$store.state.testInfo
    },
    // 重庆科协考试判断
    isChongQing() {
      const path = sessionStorage.getItem('path')
      const arrPath = ['mncq', 'zscq', 'cq']
      const examId = localStorage.getItem('examId')
      const arr = [
        '1617',
        '1618',
        '1619',
        '1620',
        '3907',
        '3911',
        '3909',
        '3910'
      ]
      return arr.includes(examId) || arrPath.includes(path)
    },
    // 判断是否是游客账号
    isTouristsId() {
      const isTourists = getTouristsVal()
      return !!isTourists
    },
    // 山东科协项目
    shandongKeXieInfo() {
      return this.shandongKeXieList.find(
        (el) => el.examId === this.testInfo.exam_id
      )
    }
  },
  watch: {
    testInfo(n) {
      const isTourists = getTouristsVal()
      if (!n.start) {
        // 该站点没有考试
        this.hasNoTest = true
        return
      }
      if (n.exam_status === 3) {
        this.$message.warning('考试已结束')
        this.$router.push({ name: 'list' })
        return
      } else if (isTourists && this.testInfo.examinee_status >= 4) {
        this.$message.info('答卷已提交')
        this.$router.push({ name: 'list' })
      }
      this.hasNoTest = n.exam_status === 0 // exam_status： 0-草稿 1-未开始 2-进行中 3-已结束 4-已中止
    }
  },
  data() {
    return {
      loading: true,
      showTime: true,
      hasNoTest: false,
      time: 0,
      needIdentity: false,
      btnLoading: false,
      showDetectModal: false,
      shandongKeXieList: [],
      showCommitmentModal: false
    }
  },
  async mounted() {
    if (this.$route.query.examId) {
      // 外链带examId过来
      localStorage.examId = this.$route.query.examId
    }
    if (localStorage.examId) {
      // 从列表进入
      await this.$store.dispatch('getTestInfo', false)
      await this.$store.dispatch('getTestConfig')
    } else {
      // 本地无examId
      this.$router.push({ name: 'list' })
      return
    }
    this.fetchShandongKexie()
    await this.$store.dispatch('getCodemaoUserInfo')
    this.needIdentity = localStorage.getItem('needIdentity') === 'true'
    this.$store.dispatch('setMonitorReport', { type: 3 }) // 上报考试监控埋点，进入候考
  },
  methods: {
    listen(time) {
      if (time - this.testInfo.start_time >= 0) {
        this.closeTime()
      }
    },
    closeTime() {
      this.testInfo.startExaminee = true
      this.$store.commit('SETSTATE', {
        key: 'testInfo',
        value: this.testInfo
      })
      this.showTime = false
    },
    async close() {
      this.$router.push({ name: 'list' })
    },
    async startTest(needCheckDevice = true) {
      if (this.showTime) return
      if (this.theme.deviceCheckOpen && needCheckDevice) {
        // 先判断是否需要设备检测
        this.showDetectModal = await this.checkDetect()
        if (this.showDetectModal) {
          return
        }
      }
      const showCommitment = await this.checkOpenCommitment()
      if (showCommitment) {
        this.showCommitmentModal = true
        return
      }
      this.btnLoading = true
      await post(
        `/home/edu/examinees/start/${this.testInfo.exam_id}/${this.testInfo.examinee_id}`
      )
      localStorage.setItem('user_id', this.$store.state.user.id)
      localStorage.removeItem('currentQuestionId')
      this.$router.push({ name: 'test', params: { noAllowBack: true } })
      this.btnLoading = false
    },
    async checkDetect() {
      // 判断该设备是否需要设备检测
      const finger = this.$store.state.browserFinger
      const { deviceCheckInfo } = await get(
        `/home/devices/check/info?serialNumber=${finger}`
      )
      return Object.values(deviceCheckInfo).some(
        ({ deviceStatus, deviceType }) =>
          this.theme.deviceTypes.includes(deviceType) && !deviceStatus
      )
    },
    goDetect() {
      this.$refs.detectRef.goDetect()
    },
    // 拉取山东科协考试数据列表
    async fetchShandongKexie() {
      try {
        this.loading = true
        const env = CONFIG.env === 'production' ? '' : `-${CONFIG.env}`
        const { data } = await axios.get(
          `https://source-static.codemao.cn/shandongkexie${env}.json`,
          { params: { _: Date.now() }, withCredentials: false }
        )
        this.loading = false
        if (data) {
          this.shandongKeXieList = data
        }
      } catch (e) {
        console.log(e)
        this.loading = false
      }
    },
    // 检测是否需要弹考试承诺
    async checkOpenCommitment() {
      let { exam_config } = this.$store.state.examConfig
      const examId = this.$route.query.examId || localStorage.getItem('examId')
      // 为了兼容从其他系统直接跳转过来拿不到数据的情况
      if (!exam_config) {
        try {
          const data = await get(`/home/exams/check/${examId}`) // 配置信息
          exam_config = data.exam_config
        } catch (e) {
          this.$router.push({ name: 'list' })
          return
        }
      }
      // 是否配置了考前承诺，1 配置，0 未配置
      const commitmentConfig = exam_config.find(item => item.label === 'LARGE_EXAM#exam_commitment')
      const commitment = commitmentConfig && commitmentConfig.actual_value
      const isAgreeOfExamId = localStorage.getItem(`exam_commitment_${examId}`)
      return !!parseInt(commitment) && !isAgreeOfExamId
    }
  }
}
</script>

<style lang="scss" scoped>
.pretest {
  height: 100%;
  width: 100%;
  background-color: #fafafa;
  padding-top: 180px;
}
.main-content {
  width: 1000px;
  min-height: 560px;
  background-color: #fff;
  margin: 0 auto;
  text-align: center;
  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.06);
  border-radius: 8px;
  padding-bottom: 25px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  h2 {
    font-size: 27px;
    font-weight: 500;
    color: #333;
    padding: 40px 0 6px 0;
  }
}
.tip {
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 0.5px;
  font-weight: 300;
}
.time-wrap {
  .time {
    font-size: 48px;
    font-weight: 500;
    height: 46px;
    line-height: 48px;
    text-align: center;
    margin: 22px auto -2px;
    color: #306fff;
  }
  .time-txt {
    display: flex;
    justify-content: center;
  }
  .time-space {
    margin: 0 84px 0 80px;
  }
  span {
    font-size: 12px;
    color: #306fff;
    font-weight: 300;
  }
}
.info-wrap {
  width: 920px;
  min-height: 300px;
  margin: 30px auto;
  background-color: #fafafa;
  padding-bottom: 25px;
  h3 {
    font-size: 21px;
    color: #333;
    letter-spacing: 1px;
    padding: 20px 0 26px 0;
  }
  .info {
    width: 630px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin: 0 auto;
  }
  .row {
    text-align: left;
    margin-bottom: 12px;
    display: flex;
    font-size: 16px;
  }
  .label {
    position: relative;
    display: inline-block;
    padding-right: 16px;
    width: 85px;
    text-align: justify;
    text-align-last: justify;
    font-weight: 500;
    &:after {
      position: absolute;
      content: '：';
    }
  }
  .text {
    display: inline-block;
    width: 200px;
    font-weight: 300;
  }
  .no-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    .icon {
      width: 100px;
      height: 87px;
      background: url("~@/assets/images/none.png") center/cover no-repeat;
      margin: 30px auto 16px auto;
    }
  }
}
.error-tip {
  color: #ff5030;
  font-size: 14px;
}
.bottom {
  width: 920px;
  margin: 0 auto;
  border-top: 1px solid #f0f0f0;
  padding-top: 25px;
  .close-btn {
    @include theme-fill-btn(136px, 40px, 16px, 4px);
  }
  .start-btn {
    @include theme-fill-btn(240px, 40px, 16px, 4px);
    &:hover {
      opacity: 0.8;
    }
    &.disabled {
      background: #b5c6e4 !important;
      box-shadow: none !important;
      cursor: not-allowed !important;
      color: #fff;
      &:hover {
        opacity: 1;
      }
    }
    /deep/.spinner {
      margin-right: 4px;
      display: inline-block;
    }
  }
  .check-btn {
    @include theme-empty-btn(240px, 40px, 16px, 4px);
    margin-right: 10px;
  }
}
</style>
